import { Messages } from '../../../../codegen/Localize';
import { openManageItemsInCollectionsDialogAction } from '../../../../Collections/actions/ManageItemsInCollectionAction';
import { MAX_ITEMS_PER_COLLECTION } from '../../../../Collections/space/ManageItemsInCollectionsDialog';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { anyItemIsEmbeddedDatasource } from './IEntityActionHelpers';

export const OpenManageItemsInCollectionsDialogEntityAction: IEntityAction<IContentInfo, {}> = {
  name: EntityActionNames.AddToCollections,
  translateName: Messages.addToCollections,
  isVisible: (targetItems: IContentInfo[]) => {
    return FeatureFlags.collectionsEnabled && targetItems.length > 0 && !anyItemIsEmbeddedDatasource(targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IContentInfo[]) => {
    return targetItems.length <= MAX_ITEMS_PER_COLLECTION;
  },
  createReduxAction: (targetItems: IContentInfo[]) => openManageItemsInCollectionsDialogAction(targetItems)
};
